import Api from "~/core/helper/apiHelper";
const { join } = require("urlcat");

const USER = "user";

export function getLectureView(callback) {
  return Api.get(join(join(USER, "/", "lecture"), "/", "view"), callback);
}
